// get all posts
export const postsQuery = `*[_type == "post"]{
    _id,
    title,
    slug,
    contributor->{
        _id,
        slug,
        name
    },
    mainImage,
    category->{
        _id,
        title,
        slug
    },
    date,
    _updatedAt,
    location,
    username,
    body
}`

// get a single post by its slug
export const postQuery = `*[_type == "post" && slug.current == $slug][0]{
    _id,
    title,
    slug,
    contributor->{
        _id,
        slug,
        name
    },
    mainImage,
    category->{
        _id,
        title,
        slug
    },
    date,
    _updatedAt,
    location,
    username,
    body
}`

// get all posts under one category
export const postCategoryQuery = `*[_type == "post" && category._ref == $categoryId]{
    _id,
    title,
    slug,
    contributor->{
        _id,
        slug,
        name
    },
    mainImage,
    category->{
        _id,
        title,
        slug
    },
    date,
    _updatedAt,
    location,
    username,
    body
}`

// get all posts under one contributor
export const postContributorQuery = `*[_type == "post" && contributor._ref == $contributorId]{
    _id,
    title,
    slug,
    contributor->{
        _id,
        slug,
        name
    },
    mainImage,
    category->{
        _id,
        title,
        slug
    },
    date,
    _updatedAt,
    location,
    username,
    body
}`